<template>
  <div class="driver-score-card">
    <div class="flex items-center justify-between mb-3">
      <span class="text-xs font-bold text-gray-400 uppercase tracking-wide">Driver Score</span>
      <span
        :class="[
          'text-sm font-bold px-2 py-0.5 rounded',
          scoreColorClass
        ]"
      >{{ displayScore }}/100</span>
    </div>

    <!-- Score bar -->
    <div class="w-full bg-gray-700 rounded-full h-2.5 mb-4">
      <div
        :class="['h-2.5 rounded-full transition-all duration-500', scoreBarClass]"
        :style="{ width: displayScore + '%' }"
      ></div>
    </div>

    <!-- Metrics grid -->
    <div class="grid grid-cols-2 gap-2">
      <div class="bg-gray-800 rounded p-2">
        <div class="text-xs text-gray-500">Avg Speed</div>
        <div class="text-sm font-bold text-white">{{ metrics.avgSpeed }} km/h</div>
      </div>
      <div class="bg-gray-800 rounded p-2">
        <div class="text-xs text-gray-500">Hard Brakes</div>
        <div class="text-sm font-bold text-white">{{ metrics.hardBrakes }}</div>
      </div>
      <div class="bg-gray-800 rounded p-2">
        <div class="text-xs text-gray-500">Overspeed</div>
        <div class="text-sm font-bold text-white">{{ metrics.overspeedEvents }}</div>
      </div>
      <div class="bg-gray-800 rounded p-2">
        <div class="text-xs text-gray-500">Distance</div>
        <div class="text-sm font-bold text-white">{{ metrics.totalDistance }} km</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    score: {
      type: Number,
      default: 0
    },
    metrics: {
      type: Object,
      default() {
        return {
          avgSpeed: 0,
          hardBrakes: 0,
          overspeedEvents: 0,
          totalDistance: 0
        };
      }
    }
  },
  computed: {
    displayScore() {
      return Math.round(this.score || 0);
    },
    scoreColorClass() {
      if (this.displayScore >= 80) return 'bg-green-900 text-green-300';
      if (this.displayScore >= 60) return 'bg-yellow-900 text-yellow-300';
      return 'bg-red-900 text-red-300';
    },
    scoreBarClass() {
      if (this.displayScore >= 80) return 'bg-green-500';
      if (this.displayScore >= 60) return 'bg-yellow-500';
      return 'bg-red-500';
    }
  }
};
</script>
